module.exports = __webpack_public_path__ + "static/media/Business-Plan-amico.044df481.png";